import api from '../../shared/api/axios';
import type {
    Service,
    ServiceCustomerDetailsOutput,
    ServiceCustomer,
    ServiceCustomerInput,
    ServiceCustomerFrequencyInput,
    ServiceInput,
    AvailableCustomer,
} from './types';

export const fetchServices = async () => {
    const { data } = await api.get<Service[]>('/services');
    return data;
};

export const fetchServicesDetails = async () => {
    const { data } = await api.get<ServiceCustomerDetailsOutput[]>('/services/details');
    return data;
};

export const fetchAvailableCustomers = async () => {
    const { data } = await api.get<AvailableCustomer[]>('/services/availablecustomers');
    return data;
};

export const createServiceSubscription = async (payload: ServiceCustomerInput) => {
    const { data } = await api.post<ServiceCustomer>('/services/subscribe', payload);
    return data;
};

export const updateServiceFrequency = async (payload: ServiceCustomerFrequencyInput) => {
    const { data } = await api.put<ServiceCustomer>('/services/frequency', payload);
    return data;
};

export const createService = async (payload: ServiceInput) => {
    const { data } = await api.post<Service>('/services', payload);
    return data;
};
